export default __webpack_public_path__ + "static/media/image1.46c4fdec.svg";